import { render, staticRenderFns } from "./CardDetailInfo.vue?vue&type=template&id=1f2c5a9e&scoped=true&"
import script from "./CardDetailInfo.vue?vue&type=script&lang=js&"
export * from "./CardDetailInfo.vue?vue&type=script&lang=js&"
import style0 from "./CardDetailInfo.vue?vue&type=style&index=0&id=1f2c5a9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2c5a9e",
  null
  
)

export default component.exports